import userService from '../../services/user.service';
import {
  APPLICATION_REFRESH_DATE,
  APP_INIT_DEFERRED,
  AUTH_LOGIN,
  AUTH_UPDATE_TOKEN,
  OWNERS_UPDATE,
  WORKSPACES_SELECT_WORKSPACE,
} from '../actions';
import { getOwners } from '../actions/owners.actions';
import { updateStateToStorage } from '../actions/storage.actions';

export const ownersFetchedMiddleware =
  ({ dispatch }) =>
  next =>
  action => {
    next(action);

    if (action.type === OWNERS_UPDATE) {
      dispatch(updateStateToStorage());
    }
  };

export const ownersInitMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_INIT_DEFERRED ||
      action.type === AUTH_UPDATE_TOKEN ||
      action.type === APPLICATION_REFRESH_DATE ||
      action.type === WORKSPACES_SELECT_WORKSPACE
    ) {
      if (!userService.isAuthenticated) return false;

      dispatch(getOwners());
    }
  };

export const ownersMiddleware = [ownersFetchedMiddleware, ownersInitMiddleware];
